import React, { useState } from "react";
import StudyDropDown from "../../common/components/StudyDropDown";
import { Box } from "@mui/material";
import DetailAssignments from "./components/DetailAssignments";
import AgendaList from "./components/AgendaList";

const AdminAssignmentPage = () => {
  const [selectedAgenda, setSelectedAgenda] = useState(null); // New state to toggle view
  const [selectedStudy, setSelectedStudy] = useState(null);

  const handleStudyChange = (event) => {
    setSelectedAgenda(null);
    setSelectedStudy(event.target.value);
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box container spacing={2} alignItems="center">
        <StudyDropDown
          selectedStudy={selectedStudy}
          handleStudyChange={handleStudyChange}
        />
        {selectedAgenda ? (
          <DetailAssignments
            selectedAgenda={selectedAgenda}
            onHandleBack={() => setSelectedAgenda(null)}
          />
        ) : (
          <AgendaList
            selectedStudy={selectedStudy}
            setSelectedAgenda={setSelectedAgenda}
          />
        )}
      </Box>
    </Box>
  );
};

export default AdminAssignmentPage;
